export const awardButtonStatus = {
    PENDING: 'notReceived',
    FULFILLED: 'received',
    REJECTED: 'notAvailable'
};

export const awardLocationStatus = {
    UNINITIALIZED: 'uninitialized',
    PENDING: 'pending',
    FULFILLED: 'fulfilled',
    REJECTED: 'rejected'
};

export const awardIssueStatus = {
    PENDING: 'pending',
    FULFILLED: 'fulfilled'
    // REJECTED: 'rejected'
};

export const issueDialogTitle = {
    success: '领取成功',
    received: '您已领取过奖励'
};



// WEBPACK FOOTER //
// ./src/views/marketing/components/leads-award/helpers.js